export default __webpack_public_path__ + "static/media/gp-icon-active.2dc0a93c.svg";